import React, {useEffect, useState} from 'react';
import {Modal, Toast, Button} from 'antd-mobile-v2';
import BackHeader from '@comp/BackHeader/index';
import FixedFooter from '@comp/FixedFooter/index';
import {fetchPatientList, updateDefPatient, delPatient} from '@/store/api/user';
import {getUser, safePhone, storage} from '@/utils/tools';

import './index.less';

export default function (props) {
  const cp = storage.get('PATIENT_INFO');
  const isChoose = !!cp;
  console.log('fff', props);
  const {tag} = props.match.params;
  const isCheck = /select|selectguardian/.test(tag); // 选择就诊人
  const isGu = tag === 'selectguardian'; // 选择监护人
  const {user_id} = getUser();
  // const user_id = '10000003368818';
  const [list, setList] = useState([]);

  useEffect(() => {
    requestPatientList();
  }, []);

  const requestPatientList = async () => {
    Toast.loading('数据加载中...', 0);
    let {family_details, status, message} = await fetchPatientList({
      user_id,
      page_no: '1',
      page_size: '999',
    });
    Toast.hide();
    if (status === '0') {
      if (isCheck) {
        family_details.forEach(item => (item.checked = item.family_default === 1));

        if (isChoose) {
          const idx = family_details.findIndex(item => item.record_id === cp.patient_id);
          if (idx >= 0) {
            onCheck(family_details, idx, list => {
              family_details = list;
            });
          } else {
            // checkDef(family_details);
          }
        } else {
          // if (!isGu) {
          //   checkDef(family_details);
          // }
        }
      }
      if (isGu) family_details = family_details.filter(item => item.family_age >= 18);

      setList(family_details);
    } else {
      setList([]);
      Toast.fail(message);
    }
  };

  const checkDef = arr => {
    const a = arr.filter(item => (item.checked = item.family_default === 1));
    handlePatientData(a[0]);
  };

  const setDef = async record_id => {
    Toast.loading('数据加载中...', 0);
    const {status, message} = await updateDefPatient({
      user_id,
      record_id,
    });
    Toast.hide();
    if (status === '0') {
      requestPatientList();
    } else {
      Toast.fail(message);
    }
  };

  const onSetDef = (e, record_id) => {
    e.stopPropagation();
    setDef(record_id);
  };

  const onCheck = (list, idx, cb) => {
    if (!isCheck) return;
    let arr = [...list];
    arr.forEach(item => (item.checked = false));
    arr[idx].checked = true;

    if (cb) {
      cb(arr);
    } else {
      setList(arr);
      handlePatientData(arr[idx]);
      props.history.go(-1);
      // location.href = location.origin + '/confirmorders?type=1';
    }
  };

  const handlePatientData = data => {
    storage.set(isGu ? 'GU_INFO' : 'PATIENT_INFO', {
      patient_age: data.family_age,
      patient_id: data.record_id,
      patient_name: data.family_name,
      patient_phone: data.family_phone,
      patient_sex: data.family_sex,
      patient_uid: data.patient_uid,
      reservation_phone: data.family_phone,
    });
  };

  const onDel = item => {
    Modal.alert('删除', '删除患者将会同时删除咨询记录，您确定要删除吗？', [
      {text: '取消', onPress: () => console.log('cancel')},
      {
        text: '确定',
        onPress: async () => {
          const {status, message} = await delPatient({record_id: item.record_id, user_id: item.user_id});
          if (status === '0') {
            Toast.success('删除成功', 1, () => {
              requestPatientList();
            });
          } else {
            Toast.fail(message);
          }
        },
      },
    ]);
  };

  return (
    <section className="page">
      <BackHeader title="就诊人管理" />
      <article className="main patient-list">
        {list.map((item, idx) => (
          <div
            className={`patient-list-item ${item.checked ? 'checked' : ''}`}
            key={item.record_id}
            onClick={e => {
              onCheck(list, idx);
            }}
          >
            {item.family_default === 1 ? (
              <div className="def-tag">
                <span>默认</span>
              </div>
            ) : (
              ''
            )}
            <div className="info">
              <span>{item.family_name}</span>
              <span>{item.family_sex === 1 ? '男' : '女'}</span>
              <span>{item.family_age}岁</span>
              {item.has_medicare_card === 1 ? <span className="tag-yb">医保</span> : ''}
              {item.id_card ? <span className="tag-yb">已实名</span> : ''}
              <span className="phone">{safePhone(item.family_phone)}</span>
            </div>
            {isGu ? (
              ''
            ) : (
              <div className="action">
                {/*<Checkbox checked={item.family_default === 1} onSetDef={e => onSetDef(e, item.record_id)}>*/}
                {/*  <span className="label">默认就诊人</span>*/}
                {/*</Checkbox>*/}
                {item.family_default !== 1 ? (
                  <Button className="btn-def" type="warning" onClick={e => onSetDef(e, item.record_id)}>
                    设为默认就诊人
                  </Button>
                ) : (
                  ''
                )}
                <div
                  className="btn btn-edit"
                  onClick={e => {
                    e.stopPropagation();
                    props.history.push(`/patient/edit?record_id=${item.record_id}&user_id=${item.user_id}`);
                  }}
                >
                  编辑
                </div>
                <div
                  className="btn btn-del"
                  onClick={e => {
                    e.stopPropagation();
                    onDel(item);
                  }}
                >
                  删除
                </div>
              </div>
            )}
          </div>
        ))}
      </article>
      {!isGu ? (
        <FixedFooter>
          <div className="btn-next" onClick={() => props.history.push('/patient/add')}>
            + 新增就诊人
          </div>
        </FixedFooter>
      ) : (
        ''
      )}
    </section>
  );
}
